/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_D2dInputs */

const en_mk_sol_startup_d2d = /** @type {(inputs: Mk_Sol_Startup_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A “spec feature X” issue is assigned to the Product agent; it reads the related issues and drafts user stories for a human to check.`)
};

const id_mk_sol_startup_d2d = /** @type {(inputs: Mk_Sol_Startup_D2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue "spec fitur X" di-assign ke agen Product; ia membaca issue terkait dan menyusun draf user story untuk diperiksa manusia.`)
};

/**
* | output |
* | --- |
* | "A “spec feature X” issue is assigned to the Product agent; it reads the related issues and drafts user stories for a human to check." |
*
* @param {Mk_Sol_Startup_D2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_d2d = /** @type {((inputs?: Mk_Sol_Startup_D2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_D2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_d2d(inputs)
	return en_mk_sol_startup_d2d(inputs)
});